import { servicePayments } from "../servicePayments";
import { IWorkDefinitionResponse } from "@wingspanhq/payments/dist/interfaces/api/workDefinition";
import { ListRequestQuery } from "../../utils/serviceHelper";

export const getPayerEngagementsWorkDefinitions = async (
  {
    payerId,
    engagementId
  }: {
    payerId: string;
    engagementId: string;
  },
  params: ListRequestQuery
): Promise<Array<IWorkDefinitionResponse>> => {
  const { data } = await servicePayments.get(
    `/payer/${payerId}/engagement/${engagementId}/work-definition`,
    {
      params
    }
  );
  return data;
};
